import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const user = params.get('user');

    if (token && user) {
      // Store the token and user data
      localStorage.setItem('token', token);
      localStorage.setItem('user', user);
      
      // Redirect to home page or dashboard
      navigate('/');
    } else {
      // Handle error case
      console.error('Authentication failed');
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500 mx-auto mb-4"></div>
        <p className="text-white/70">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback; 